// src/icons/unlockedprofileicon.js
import React from 'react';

export default function UnlockedProfileIcon({ size = 24, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icon-tabler-lock-open-2"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z" />
      <path d="M9 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" />
      <path d="M13 11v-4a4 4 0 1 1 8 0v4" />
    </svg>
  );
}
